export const environment = {
  production: false,
  configPath: 'assets/configs/discount-hub.config.json',
  keycloakUrl: 'https://auth.dev.simadvisory.com/auth',
  realm: 'D_SPRICED',
  clientId: 'D_SPRICED_Client',
  base_url: 'https://dev-hub.alpha.simadvisory.com',
  uploadBatchSize: 5000
};
